<template>
  <el-dialog :title="form.id?'编辑内部员工':'添加内部员工'" :visible.sync="formVisible" :close-on-click-modal="false" width="1000px">
    <el-form ref="dataForm" label-position="right" :rules="formRules" :model="form" size="small"
      label-width="130px">
      <el-form-item label="当前部门：" prop="deptName" v-if="popType==2" class="width100">
        <el-input v-model="form.deptName" disabled />
      </el-form-item>
      <el-form-item :label="popType==2?'修改部门：':'部门：'" prop="deptId" class="width100">
        <el-select v-model="form.deptId" placeholder="请选择">
          <el-option :label="item.value" :value="item.key" v-for="item in sectionList" :key="item.key"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="姓名：" prop="realName" class="width100" v-if="popType!=2"
        :rules="[{required: true,message: '请输入内部员工的姓名',trigger: 'blur'}]">
        <el-input v-model="form.realName" placeholder="请输入内部员工的姓名" />
       <!-- <el-autocomplete class="inline-input" v-model="form.realName" :fetch-suggestions="querySearch1"
          placeholder="请输入内部员工的姓名"  :trigger-on-focus="false" @select="handleSelect1">
        </el-autocomplete> -->
        <!-- <el-autocomplete class="inline-input" v-model="form.realName" placeholder="请输入内部员工的姓名"
          :fetch-suggestions="querySearch1" :trigger-on-focus="false" @select="handleSelect1"></el-autocomplete> -->
      </el-form-item>
      <el-form-item label="手机号：" prop="userPho" class="width100" v-if="popType!=2"
        :rules="[{required: true,message: '请输入手机号',trigger: 'blur'},{ pattern: /^[0-9]*$/, message: '请输入正确的手机号'}]">
        <el-input v-model="form.userPho" placeholder="请输入手机号" maxlength="11"/>

        <!-- <el-autocomplete class="inline-input" v-model="form.userPho" :fetch-suggestions="querySearch"
          placeholder="请输入手机号" maxlength="11" :trigger-on-focus="false" @select="handleSelect">
        </el-autocomplete> -->
        <!-- <el-autocomplete class="inline-input" v-model="form.userPho" placeholder="请输入手机号" maxlength="11"
          :fetch-suggestions="querySearch" :trigger-on-focus="false" @select="handleSelect"></el-autocomplete> -->
      </el-form-item>
      <el-form-item label="性别" prop="sex" v-if="popType!=2">
        <el-radio-group v-model="form.sex">
          <el-radio :label="1">男</el-radio>
          <el-radio :label="2">女</el-radio>
        </el-radio-group>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="formVisible = false">
        取消
      </el-button>
      <el-button type="primary" @click="doCreate()" :loading="isLoading">
        确认
      </el-button>
    </div>
  </el-dialog>
</template>

<script>
  import userApi from '@/api/sys/user'
  import clientListApi from '@/api/client/clientList'
  function initFormBean() {
    const formBean = {
      realName: null,
      userPho: null,
      deptId: null,
      sex: 1,
      isInternal: 1,
      jobStatus: 1,
      entryInhibited: 0,
      userType: 2
    }
    return formBean
  }

  export default {
    //popType 0:新增 1:编辑 2:修改身份
    props: {
      sectionList: Array,
      popType: Number,
      optionNameList: Array,
      optionPhoList: Array
    },
    data() {
      return {
        form: initFormBean(),
        isLoading:false,
        formVisible: false,
        formRules: {
          deptId: [{
            required: true,
            message: '请选择部门',
            trigger: 'change'
          }],
          // realName: [{
          //   required: true,
          //   message: '请输入内部员工的姓名',
          //   trigger: 'blur'
          // }],
          // userPho: [{
          //   required: true,
          //   message: '请输入手机号',
          //   trigger: 'blur'
          // }],
        },
      }
    },
    created() {
      // console.log('optionNameList: ',this.optionNameList);
    },
    methods: {
      // querySearch(queryString, cb) {
      //   let obj = {
      //     // customerTypes: 2,
      //     isGetAllParent: true,
      //     // isDeparted: 0,
      //     pageNo: 1,
      //     pageSize: 100,
      //     CLevel: 8,
      //     pho: queryString
      //   }
      //   let phoList = []
      //   clientListApi.getListPageForMini(obj).then(res=>{
      //     if (res.code == 0) {
      //       //如果搜索结果为空返回“无匹配结果”
      //       if (res.data.list.length == 0) {
      //         phoList.push({
      //           value1: "无匹配结果",
      //           value: "无匹配结果",
      //           id: -1
      //         })
      //         cb(phoList)
      //       } else {
      //         //对获取的值进行遍历，调整数据结构，value
      //         for (let i = 0; i < res.data.list.length; i++) {
      //           //需要注意的是回显的值必须是一个对象数组，且对象属性名称是 “value”，不然回显失败
      //           phoList.push({
      //             value1: res.data.list[i].name,
      //             // label: `${res.data.list[i].name}-${res.data.list[i].pho}`,
      //             value: `${res.data.list[i].name}`,
      //             id: res.data.list[i].id
      //           })
      //         }
      //         clearTimeout(this.timeout)
      //         this.timeout = setTimeout(() => {
      //           cb(phoList)
      //           //通过callBack函数将回显数据返回
      //         }, 1000)
      //       }
      //     } else {
      //       this.$message({
      //         type: 'error',
      //         message: '请求失败'
      //       });
      //     }
      //   })

        // var restaurants = this.optionPhoList;
        // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // // 调用 callback 返回建议列表的数据
        // cb(results);
      // },
      // createFilter(queryString) {
      //   console.log('queryString22: ',queryString);
        // return (restaurant) => {
        //   return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        // };
      // },
      // querySearch1(queryString, cb) {
      //   let obj = {
      //     // customerTypes: 2,
      //     isGetAllParent: true,
      //     // isDeparted: 0,
      //     pageNo: 1,
      //     pageSize: 100,
      //     CLevel: 8,
      //     name: queryString
      //   }
      //   let nameList = []
      //   clientListApi.getListPageForMini(obj).then(res=>{
      //     if (res.code == 0) {
      //       //如果搜索结果为空返回“无匹配结果”
      //       if (res.data.list.length == 0) {
      //         nameList.push({
      //           value1: "无匹配结果",
      //           value: "无匹配结果",
      //           id: -1
      //         })
      //         cb(nameList)
      //       } else {
      //         //对获取的值进行遍历，调整数据结构，value
      //         for (let i = 0; i < res.data.list.length; i++) {
      //           //需要注意的是回显的值必须是一个对象数组，且对象属性名称是 “value”，不然回显失败
      //           nameList.push({
      //             value1: res.data.list[i].pho,
      //             // label: `${res.data.list[i].name}-${res.data.list[i].pho}`,
      //             value: `${res.data.list[i].name}`,
      //             id: res.data.list[i].id
      //           })
      //         }
      //         clearTimeout(this.timeout)
      //         this.timeout = setTimeout(() => {
      //           cb(nameList)
      //           //通过callBack函数将回显数据返回
      //         }, 1000)
      //       }
      //     } else {
      //       this.$message({
      //         type: 'error',
      //         message: '请求失败'
      //       });
      //     }
      //   })

        // var restaurants = this.optionPhoList;
        // var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        // // 调用 callback 返回建议列表的数据
        // cb(results);
      // },
      // createFilter1(queryString) {
      //   console.log('queryString111: ',queryString);
        // return (restaurant) => {
        //   return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
        // };
      // },
      // querySearch1(queryString, cb) {
      //   var restaurants = this.optionNameList;
      //   var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
      //   // 调用 callback 返回建议列表的数据
      //   cb(results);
      // },
      // createFilter1(queryString) {
      //   return (restaurant) => {
      //     return (restaurant.value.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      //   };
      // },
      handleSelect(item) {
        // console.log('111',item);
        this.form.realName = item.value2
      },
      handleSelect1(item) {
        // console.log('222',item);
        this.form.userPho = item.value2
      },
      resetForm() {
        this.form = initFormBean()
      },
      handleCreate() {
        this.resetForm()
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      handleUpdate(row) {
        // console.log('row: ',row);
        this.resetForm()
        this.form = {
          ...row
        }
        this.formVisible = true
        this.$nextTick(() => {
          this.$refs['dataForm'].clearValidate()
        })
      },
      doCreate() {
        this.$refs["dataForm"].validate((valid) => {
          if (valid) {
            // console.log('this.form: ', this.form);
            this.isLoading = true
            if (this.form.id) {
              userApi.update(this.form).then((data) => {
                this.postCallback(data)
              }).catch(res=>{
                this.isLoading=false
              });
            } else {
              userApi.create(this.form).then((data) => {
                this.postCallback(data)
              }).catch(res=>{
                this.isLoading=false
              });
            }
          }
        });
      },
      postCallback(data) {
        this.$message.success('操作成功')
        this.formVisible = false;
        this.$emit('created')
        this.isLoading=false
      },
    }
  }
</script>
<style lang="scss" scoped>
  ::v-deep .el-select {
    width: 100%;
  }

  ::v-deep .el-cascader {
    width: 100%;
  }

  ::v-deep .el-input {
    width: 100%;
  }

  ::v-deep .el-autocomplete {
    width: 100%;
  }

  .el-form-item--small.el-form-item {
    width: 48%;
    display: inline-block;
    vertical-align: top;
  }

  .el-date-editor--datetimerange.el-input,
  .el-date-editor--datetimerange.el-input__inner {
    width: 100%;
  }

  .el-form-item--small.el-form-item.width100 {
    width: 97%;
  }
</style>
